import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="container py-5">
          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading mb-3">Bir hata oluştu</h4>
            <p className="mb-2">
              {this.state.error?.message || "Beklenmeyen bir hata oluştu."}
            </p>
            {process.env.NODE_ENV === "development" && (
              <pre
                className="mt-3 p-3 bg-light border rounded small"
                style={{ whiteSpace: "pre-wrap" }}
              >
                {this.state.error?.stack}
                {"\n\n"}
                {this.state.errorInfo?.componentStack}
              </pre>
            )}
            <div className="mt-3 d-flex gap-2">
              <button
                className="btn btn-outline-secondary"
                onClick={this.handleReload}
              >
                Sayfayı Yeniden Dene
              </button>
              <button
                className="btn btn-light"
                onClick={() =>
                  navigator.clipboard.writeText(
                    `${this.state.error?.stack || ""}\n\n${
                      this.state.errorInfo?.componentStack || ""
                    }`
                  )
                }
              >
                Hata Detayını Kopyala
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
